module.exports = __webpack_public_path__ + "c51ba606f4d5223d4ea06c9b514f4d5a.jpg";